module.exports = __webpack_public_path__ + "static/media/floccc.ffcb17b4.svg";